<template>
  <el-dialog
    title="导出设置"
    :visible.sync="visible"
    @close="close"
    width="80%"
  >
  <div class="content">
    <div class="item">
      <div class="title">导出范围</div>
      <el-checkbox-group v-model="checkList" :min="1">
        <el-checkbox label="错词"/>
        <el-checkbox label="疑问词"/>
        <el-checkbox label="敏感词"/>
      </el-checkbox-group>
    </div>
    <div class="item">
      <div class="title">导出模式</div>
      <!-- <el-radio v-model="radio" label=".csv">.csv</el-radio> -->
      <el-radio v-model="radio" label=".docx">.docx</el-radio>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="close">取 消</el-button>
    <el-button type="primary" @click="submit">确 定</el-button>
  </span>
</el-dialog>
</template>

<script>
export default {
  name: 'VSetting',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      checkList: ['错词', '疑问词', '敏感词'],
      radio: '.docx',
    };
  },
  created() {
    const list = localStorage.getItem('checkList');
    this.checkList = JSON.parse(list) || this.checkList;
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    submit() {
      localStorage.setItem('checkList', JSON.stringify(this.checkList))
      this.close();
    },
  }
}
</script>

<style scoped>
.item {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.title {
  margin-bottom: 10px;
}
</style>